<script>
import Bfhs from '@views/homepage/homepage-modules/homepage-bfhs'
import FeaturedPlaylists from '@views/homepage/homepage-modules/homepage-featured-playlists'
import FeaturedCharts from '@views/homepage/homepage-modules/homepage-featured-charts'
import LatestMixes from '@views/homepage/homepage-modules/homepage-latest-mixes'
import TrendingMixes from '@views/homepage/homepage-modules/homepage-trending-mixes'
import HomeRadio from '@views/homepage/homepage-modules/homepage-radio'
import TrendingDjs from '@views/homepage/homepage-modules/homepage-trending-djs'
import PremiumBanner from '@components/premium-banner'

export default {
    name: 'UnAuthHomepage',

    components: {
        Bfhs,
        FeaturedPlaylists,
        FeaturedCharts,
        LatestMixes,
        TrendingMixes,
        HomeRadio,
        TrendingDjs,
        PremiumBanner,
    },
}
</script>

<template>
    <BaseSection
        padded
        class="homepage-container"
    >
        <Bfhs class="hero" />
        <TrendingMixes />
        <PremiumBanner source="home-banner" />
        <HomeRadio />
        <LatestMixes />
        <FeaturedPlaylists />
        <FeaturedCharts />
        <TrendingDjs />
    </BaseSection>
</template>

<style lang="scss" scoped>
@import '@design';

.homepage-container {
    display: grid;
    gap: $s-xxl;

    :deep(> *) {
        min-width: 100%;
    }

    @include tablet {
        &:has(> .hero) {
            grid-template-columns: minmax(0, 72%) minmax(0, 28%);

            :deep(> .hero:first-child) {
                grid-row: 1;
                grid-column: 2;
            }

            :deep(> .hero:first-child + *) {
                grid-row: 1;
                grid-column: 1;
            }

            :deep(> .hero:first-child ~ *:nth-child(n+3)) {
                grid-column: 1 / -1;
            }
        }
    }
}
</style>
